import { TextPoint } from '../types/homepage'

export const carePrinciples: TextPoint[] = [
  {
    title: 'Human-led care',
    description:
      'Therapists lead the care. Technology supports the work around it.',
  },
  {
    title: 'Meaningful matching',
    description:
      'Your needs, preferences, and circumstances help shape the options you explore.',
  },
  {
    title: 'Room to choose',
    description:
      'Understanding a recommendation should be part of deciding whether it feels right.',
  },
]
